import { render, staticRenderFns } from "./PatentLinks.vue?vue&type=template&id=aca7fbf6"
import script from "./PatentLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatentLinks.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports